import { render } from "./PassportRegistration.vue?vue&type=template&id=5a29113a&scoped=true"
import script from "./PassportRegistration.vue?vue&type=script&lang=js"
export * from "./PassportRegistration.vue?vue&type=script&lang=js"

import "./PassportRegistration.vue?vue&type=style&index=0&id=5a29113a&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a29113a"]])

export default __exports__